import './Upload.css'
import Own from './Own'

export default function Upload() {
    return (
        <div className='upload'>
            <div className='header'>Choose your own</div>
            <Own />
        </div>
    )
}